export const enum POSITION_TYPE {
  APPOINT = "appoint",
  ELECTION = "election",
}

export const POSITION_PRIORITY_UNIT = 1;
